"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollParent = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _rcResizeObserver = _interopRequireDefault(require("rc-resize-observer"));
var _ykbStyledComponents = _interopRequireDefault(require("../ykb-styled-components"));
var _ykbUtils = require("ykb-utils");
var _excluded = ["maximized"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var TableWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1psizrb-0"
})(["position:fixed;top:", "px;bottom:3px;right:3px;left:", "px;z-index:9999;background:#ffffff;"], function (props) {
  return props.position.top;
}, function (props) {
  return props.position.left;
});
var ObserverContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1psizrb-1"
})(["position:relative;"]);
var Placeholder = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1psizrb-2"
})(["height:100vh;"]);
var _getScrollParent = exports.getScrollParent = function getScrollParent(node) {
  if (!node) {
    return null;
  }
  if (node.scrollHeight > node.clientHeight) {
    return node;
  }
  var parent = node instanceof ShadowRoot ? node.host : node.parentNode;
  return _getScrollParent(parent);
};
var handlePosition = function handlePosition(container) {
  var scroll = _getScrollParent(container);
  var containerRect = container === null || container === void 0 ? void 0 : container.getBoundingClientRect();
  var left = Math.max((containerRect === null || containerRect === void 0 ? void 0 : containerRect.left) || 0, 0) + 3;
  var top = Math.max((containerRect === null || containerRect === void 0 ? void 0 : containerRect.top) + (scroll === null || scroll === void 0 ? void 0 : scroll.scrollTop) || 0, 0);
  return {
    left: left,
    top: top
  };
};
var enhance = function enhance(Table) {
  return function (props) {
    var maximized = props.maximized,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
    if (!maximized) {
      return /*#__PURE__*/_react.default.createElement(Table, rest);
    }
    var _useState = (0, _react.useState)((0, _ykbUtils.containerChecker)()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      container = _useState2[0];
    var _useState3 = (0, _react.useState)(handlePosition(container)),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      position = _useState4[0],
      setPosition = _useState4[1];
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Placeholder, null), /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react.default.createElement(_rcResizeObserver.default, {
      onResize: function onResize() {
        setPosition(handlePosition(container));
      }
    }, /*#__PURE__*/_react.default.createElement(ObserverContainer, null, /*#__PURE__*/_react.default.createElement(TableWrapper, {
      position: position
    }, /*#__PURE__*/_react.default.createElement(Table, (0, _extends2.default)({}, rest, {
      maximized: maximized
    }))))), container));
  };
};
var _default = exports.default = enhance;